import CustomForm from "../CustomForm";

export default abstract class Report extends CustomForm { };
